import { HttpInterceptorFn } from '@angular/common/http';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  const accessToken = localStorage.getItem('accessToken');
  const userId = localStorage.getItem('userId');
  const courseId = localStorage.getItem('courseId');

  // console.log('Header Interceptor - Access Token:', accessToken);
  // console.log('Header Interceptor - User ID:', userId);
  // console.log('Header Interceptor - Course ID:', courseId);

  const modifiedReq = req.clone({
    setHeaders: {
      Authorization: accessToken ? `Bearer ${accessToken}` : '',
      garbage: userId || '',
      courseId: courseId || '',
      accessToken: accessToken || '',
    }
  });

  return next(modifiedReq);
};
